import { deleteField } from 'firebase/firestore'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import NoData from 'global/components/alerts/NoData'
import UiSaveButtons from 'global/components/buttons/UiSaveButtons'
import CalSchedule from 'global/components/calendar/CalSchedule'
import { openExternal } from 'global/viewSettings/helpers/settingsLinks'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import TransitionWrapper from 'global/wrappers/TransitionWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import WrapperVertCols from 'global/wrappers/WrapperVertCols'
import { SquaresOptions } from 'globalAlt/components/rss/SquaresOptions'
import _ from 'lodash'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Icon, Label } from 'semantic-ui-react'
import { SportsDistrictContext } from '../cnr/contexts/SportsDistrictContext'
import { _sportsFormProps, SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext'
import { _matchFoundTypes } from '../cnr/reducers/reducerHelpers/seasonSportsMatchData'
import { gameScoringTypes } from '../cnr/reducers/SportsSeasonReducer'
import { _sdm } from '../elements/dashboard/SportsDashboard'
import { MatchPendings } from '../elements/matches/MatchPendings'
import MatchSquares, { _msTypes, matchStatusColors } from '../elements/matches/MatchSquares'
import useMediaDataOptions from '../elements/matches/useMediaDataOptions'
import { SportsSchedules } from '../elements/schedule/SportsSchedules'
import TeamSchedule from '../elements/schedule/TeamSchedule'
import { matchCalcs } from '../helpers/match'
import { useCreateSchedule } from '../useHelpers/useCreateSchedule'
import useGoogleSports from '../useHelpers/useGoogleSports'
import { _allowSportsUpdates } from '../useHelpers/useSeasonals'
import { _matchConflictTypes, useSportsMatches } from '../useHelpers/useSportsMatches'
import { useSportsSeasonData } from '../useHelpers/useSportsSeasonData'
import { MatchesExtra } from '../elements/matches/MatchesExtra'

const _categoryTypes = {
  allMatches: 'allMatches',
  missingMatchResults: 'missingMatchResults',
  cancelledMatches: 'cancelledMatches',
  matchDayMatches: 'matchDayMatches',
  matchPlayoffPending: 'matchPlayoffPending',
  teams: 'teams',
}

const _modifyShowTypes = {
  nonGs: 'nonGs',
  nonApp: 'nonApp',
  conflicts: 'conflicts',
  cancelled: 'cancelled',
  reassignedTeams: 'reassignedTeams',
  unCancelled: 'unCancelled',
  removed: 'removed',
  matchesDupped: 'matchesDupped',
  matchesMissingTiks: 'matchesMissingTiks',
  matchesTopLevel: 'matchesTopLevel',
  matchesRemove: 'matchesRemove',
  matchUpdates: 'matchUpdates',
}

const _calendarTypes = {
  calendar: 'calendar',
  list: 'list',
}

const maxMatchCount = 22

export const ModifySeasonMatches = ({ teamKey }) => {

  const {
    get_seasonalData,
    update_seasonalMatches,
    update_modifiedMatches,
    updating: updating_csd
  } = useSportsSeasonData()

  const { createSeasonMatches } = useCreateSchedule()

  const {
    getMatches_reAssignedTeams,
    getMatches_grouped,
    highlightMatchesConflicts,
    analyzeMatches,
    getMatches_dotRemoved,
    getMatches_dotCkUpdates,
    getMatches_badTeams,
    getMatches_missing,
    getMatches_toRemove,
  } = useSportsMatches()

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data, sportPermissions } = sportsDistrict_state ?? {}
  const { gls_scores } = district_data ?? {}
  const gls_score = gls_scores?.[pathViews?.sports]

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, teams_info, matches_info } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { matches_combined, matches_matchDay, matchPlayoffPendings } = matches_info ?? {}
  const { gameScoringType, currentSeason: selectedYear, sportsKey, _sportsAbr } = currentSeason_info ?? {}

  const [calendarType, setCalendarType] = useState(_calendarTypes.list)
  const [currentCategory, setCurrentCategory] = useState()
  const [currentShowType, setCurrentShowType] = useState()
  const [match_selected, setMatch_selected] = useState()
  const [matches_dupped, setMatches_dupped] = useState([])
  const [matches_gs, setMatches_gs] = useState([])
  const [matches_missingTiks_dot, setMatches_missingTiks_dot] = useState()
  const [matches_missingTiks_topLevelDot, setMatches_missingTiks_topLevelDot] = useState()
  const [matches_missingTiks, setMatches_missingTiks] = useState()
  const [matches_nonApp, setMatches_nonApp] = useState([])
  const [matches_nonGs, setMatches_nonGs] = useState([])
  const [matches_opp, setMatches_opp] = useState([])
  const [matches_reassignedTeams, setMatches_reassignedTeams] = useState([])
  const [matches_remove, setMatches_remove] = useState([])
  const [matches_season, setMatches_season] = useState(_.cloneDeep(matches_combined))
  const [matches_team_new, setMatches_teamNew] = useState([])
  const [matches_team, setMatches_team] = useState([])
  const [matches_unCancelled, setMatches_unCancelled] = useState([])
  const [matches_updates, setMatches_updates] = useState([])
  const [mode_right, setMode_right] = useState()
  const [seasonalInfo, setSeasonalInfo] = useState()
  // const [showOptions, setShowOptions] = useState()
  const [team_opponent, setTeam_opponent] = useState()
  const [team_selected, setTeam_selected] = useState(teamKey ? teams?.[teamKey] : {})

  const matchDayMatches = matches_combined && matches_matchDay ? _.pick(matches_combined, Object.keys(matches_matchDay)) : {};

  const handleMatchSelected = (m) => setMatch_selected(m ? m : null)

  const linkValues = useMemo(() => {
    const _linkValues = {}
    const form_props = _sportsFormProps[_sdm.sports.seasonResults]
    if (form_props) {
      Object.keys(form_props).forEach(fp => {
        _linkValues[fp] = gls_score?.[fp] || null
      })
    }
    return _linkValues
  }, [])

  const { handleGet_gsMatches, fetching: fetching_gs } = useGoogleSports({
    currentMenuKey: null,
    sportsDataMode: _sdm.sports.seasonResults,
    gameScoringType,
  })

  const handleMode_left = (e, ml) => {
    // e && e.stopPropagation()
    // setMode_left(ml)
  }

  const { matchDataOptions, mediaResults, fetching: fetching_mdo } = useMediaDataOptions({
    currentMenuKey: null,
    handleMode_left,
    linkValues: linkValues,
    mediaUrl: null,
    setMode_right,
    sportsData_handlers: {},
    sportsDataMode: _sdm.sports.seasonResults,
    gls_score
  })

  const fetching = fetching_gs || fetching_mdo
  const updating = fetching || updating_csd

  const handleSelect_team = (team) => {
    setTeam_selected(team)
    setTeam_opponent()
    setMatches_opp([])
    handleShowType()
  }

  const handleSelect_opponent = (team) => setTeam_opponent(team)

  useEffect(() => {
    // if 'selectedYear' changes 
    // this is for the SEASONAL INFO ONLY
    if (selectedYear) {
      const cbn = ({ _seasonalData, seasonalData, _parentDataKeys }) => {
        const { seasonals } = _seasonalData ?? {}
        const { homeAways, teams } = seasonals ?? {}
        const { matches: _matches, crossoverMatches: _crossoverMatches } = createSeasonMatches({
          homeAways: homeAways,
          sportsSeason_selected: _seasonalData,
          _sportsAbr,
          forceRefresh: true,
          matches_season
        })

        const matches_gs_cf = highlightMatchesConflicts({ matches: _matches })
        const _seasonalInfo = {
          teams,
          matches: _matches,
        }
        setSeasonalInfo(_seasonalInfo)
      }
      get_seasonalData({ selectedYear, callback: cbn })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    if (matches_season) {
      const _matches_team = _.filter(matches_season, (match) =>
        _.includes(match.teams, team_selected?._itemKey)
      );
      setMatches_team(_matches_team)
      setMatches_teamNew([])
      const { matches_remove, matches_missingTeamItemKeys, matches_missingTeamItemKeys_dot, matches_badTopLevels } = getMatches_badTeams({ matches_app: matches_season })
      setMatches_missingTiks(matches_missingTeamItemKeys)
      setMatches_missingTiks_dot(matches_missingTeamItemKeys_dot)
      setMatches_missingTiks_topLevelDot(matches_badTopLevels)
      setMatches_remove(matches_remove)

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [team_selected]);

  useEffect(() => {
    const _matches_opp = _.filter(matches_season, (match) =>
      _.includes(match.teams, team_opponent?._itemKey)
    );
    setMatches_opp(_matches_opp)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [team_opponent]);

  useEffect(() => {
    const { _reAssignedTeams } = getMatches_reAssignedTeams({ matches_season })
    setMatches_reassignedTeams(_reAssignedTeams)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [matches_season]);

  useEffect(() => {
    if (!mediaResults) return;
    const { matchResultsInfo, _forPlayoffs } = mediaResults ?? {}
    const { matchesNon_appNotGs, matchesNon_gsNotApp, matches_gs, matchUpdates, matchUpdates_dupped, matchUpdates_dot_mcks } = matchResultsInfo ?? {}
    console.log('matchUpdates_dupped', matchUpdates_dupped)
    setMatches_gs(matches_gs)
    setMatches_nonGs(matchesNon_appNotGs)
    setMatches_nonApp(matchesNon_gsNotApp)
    setMatches_dupped(matchUpdates_dupped)
    setMatches_updates(matchUpdates)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [mediaResults]);

  const missingMatches = useMemo(() => {
    return getMatches_missing({ matches_info })
  }, [matches_combined])

  const dupMatches = useMemo(() => {
    return getMatches_toRemove({ matches: matches_combined })
  }, [matches_combined])

  console.log('dupMatches', dupMatches)

  const header_matchDay = (caption, count) => <div className='header-flex'>
    <div>{caption}</div>
    <div>
      <Label size='mini' style={{ marginRight: '1em' }}>{count}</Label>
      <Icon name='external alternate' color='orange' onClick={(e) => { openExternal.realtimeDb(pathViews) }}></Icon>
    </div>
  </div>

  const header_flex = (caption, count) => <div className='header-flex'>
    <div>{caption}</div>
    <div>
      <Label size='mini'>{count}</Label>
    </div>
  </div>

  // const footer_matchDay = () => {
  //   const items = []
  //   let icon_sub = 'arrow right';
  //   btn_itemRight(items, icon_sub, 'Clear Match Day', _rightModes_mdu.confirmClearMatchDayResults, _.isEmpty(matchDayMatches))
  //   btn_itemRight(items, icon_sub, 'Commit Match Day', _rightModes_mdu.confirmMatchDayResults, _.isEmpty(matchDayMatches))
  //   return <UiSaveButtons
  //     others={items}
  //     color={'blue'}
  //   />
  // }
  const _counts = {
    matches: _.size(matches_info?.matches),
    // matches_combined: _.size(matches_info?.matches_combined),
    matches_matchDay: _.size(matches_info?.matches_matchDay),
    missing: _.size(missingMatches),
  }

  const menu_vert_matchDay = useMemo(() => {
    const count = _counts.matches_matchDay;
    const _caption = _.startCase('matchDayMatches')
    return <Wrapper
      header={header_matchDay(_caption, count)}
      content={count > 0 ? <SportsSchedules matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.matchDay}></SportsSchedules> : <NoData fullCaption={'None'} />}
      wrapperType={count > 0 ? wrapperTypes.paddedHeader : wrapperTypes.padded}
      css={{ content: count === 0 ? 'hwcc' : null }}
    ></Wrapper>
  }, [matchDayMatches]);

  const menu_vert_matchPlayoffPendings = useMemo(() => {
    const count = matchPlayoffPendings ? _.size(matchPlayoffPendings) : 0
    const _caption = _.startCase('matchPlayoffPendings')
    return <Wrapper
      header={header_flex(_caption, count)}
      content={<MatchPendings />}
      css={{ content: count === 0 ? 'hwcc' : null }}
    ></Wrapper>
  }, [matchPlayoffPendings]);

  const matches_cancelled = useMemo(() => {
    const cbn = _.filter(matches_season, { _isCancelled: true });
    return _.sortBy(cbn, 'startDate')
  }, [matches_season]);

  const matches_results = useMemo(() => {
    return _.filter(matches_season, match => !_.isEmpty(match?.results))
  }, [matches_season])

  const matches_teamsCombined = useMemo(() => {
    const cbn = _.concat(matches_team, matches_team_new);
    return _.sortBy(cbn, 'startDate')
  }, [matches_team, matches_team_new]);

  const matches_teamsUpdated = useMemo(() => {
    const cbn = _.filter(matches_team, { _updated: true });
    return _.sortBy(cbn, 'startDate')
  }, [matches_team]);

  const matches_teamsUpdates = useMemo(() => {
    const _matches = {}
    _.forEach(matches_team_new, m => {
      _matches[m._itemKey] = m
    })

    _.forEach(matches_teamsUpdated, m => {
      _matches[m._itemKey] = m
    })
    return _matches
  }, [matches_team_new, matches_teamsUpdated]);

  const matches_teamsOppCombined = useMemo(() => {
    const cbn = _.concat(matches_opp, matches_team_new);
    return _.sortBy(cbn, 'startDate')
  }, [matches_opp, matches_team_new]);

  const matches_dups = useMemo(() => {
    const grouped = _.groupBy(matches_team, 'startDate')
    return _.pickBy(
      grouped,
      matches => matches.length > 1
    )
  }, [matches_team])

  const matches_missAssigned = useMemo(() => {
    const _missAssigned = {}
    const updates_matches = {};
    _.forEach(matches_team, (match, matchKey) => {
      const { away, home, teams, id, _itemKey: _itemKey_match } = match ?? {}
      const { id: id_away, _itemKey: itemKey_away } = away ?? {}
      const { id: id_home, _itemKey: itemKey_home } = home ?? {}
      const key_match = id || _itemKey_match
      const key_away = id_away || itemKey_away
      const key_home = id_home || itemKey_home
      if (_.includes(teams, key_away) && _.includes(teams, key_home)) {
      } else {
        updates_matches[`matches.${key_match}`] = deleteField();
        _missAssigned[key_match] = match
      }
    })
    return _missAssigned
  }, [matches_team])



  const { matches_app_removed, matches_nonTeam } = useMemo(() => {
    const { matchesRemoved_dot, matches_nonTeam } = getMatches_dotRemoved({ matches_app: matches_combined })
    return { matches_app_removed: matchesRemoved_dot, matches_nonTeam }
  }, [matches_gs])

  const { matches_gs_conflicts, matches_gs_cancelled } = useMemo(() => {

    const amm = analyzeMatches({ matches_app: matches_combined, matches_gs })
    const { updates_app, matches_non } = amm ?? {}
    // const { updates_app_dot, updates_grouped } = getMatches_dotCkUpdates({ updates_app })
    const matches_gs_cf = highlightMatchesConflicts({ matches: matches_gs })
    const _matches_gs_conflicts = _.filter(matches_gs_cf, m => m._hasConflicts)
    const _matches_gs_cancelled = _.filter(matches_gs_cf, m => m.updateTypes === 'Cancelled')
    return { matches_gs_conflicts: _matches_gs_conflicts, matches_gs_cancelled: _matches_gs_cancelled }
  }, [matches_gs])

  const handleShowType = (showType) => setCurrentShowType(currentShowType ? null : showType)

  const createMatch = (newMatch, startDate, startTime) => {

    newMatch._itemKey = database_fns.get_docKey()
    newMatch.startDate = startDate || '??????'
    newMatch.startTime = startTime
    newMatch.sections = 'Non'

    switch (gameScoringType) {
      case gameScoringTypes.match:
      case gameScoringTypes.matchPoints:
        newMatch.bestOf = true
        newMatch.setCount = 5
        break;
      default:
      // nothing
    }

    newMatch.teams = [newMatch.home._itemKey, newMatch.away._itemKey]

    if (newMatch.away.levels === newMatch.home.levels) {
      newMatch.levels = newMatch.home.levels
      newMatch._matchCollectionKey = newMatch.home.levels
    } else {
      newMatch.levels = 'Non'
    }

    newMatch.ls = `${newMatch.levels} - ${newMatch.sections}`

    matchCalcs.calcVballMatch(newMatch, gameScoringType)

    return newMatch
  }

  const handleUpdate_matches = () => {
    const opts = { selectedYear, sportsKey }
    const _matches = {}

    _.forEach(matches_team_new, m => {
      _matches[m._itemKey] = m
    })

    _.forEach(matches_teamsUpdated, m => {
      _matches[m._itemKey] = m
    })

    update_seasonalMatches({
      matchesToUpdate: _matches,
      opts
    })
  }

  const handleUpdate_matchesReassigned = () => {

    const updates_matches = {}
    _.forEach(matches_reassignedTeams, (m, mk) => {
      updates_matches[`matches.${mk}.teams`] = {
        value: m.teams,
        _matchCollectionKey: m?._matchCollectionKey,
      }
    })


    const updates_matches_grouped = getMatches_grouped({ updates_matches })

    const opts = { selectedYear, sportsKey }

    update_modifiedMatches({
      groupedMatchesToUpdate: updates_matches_grouped,
      opts,
    })
  }

  const handleUpdate_matchesSelected = () => {

    let matches_current;
    let updateValue;

    switch (currentShowType) {
      case _modifyShowTypes.cancelled:
        matches_current = matches_cancelled;
        updateValue = deleteField();
        break;
      case _modifyShowTypes.nonGs:
        matches_current = matches_nonGs
        updateValue = deleteField();
        break;
      case _modifyShowTypes.unCancelled:
        matches_current = matches_unCancelled;
        updateValue = deleteField();
        break;
      case _modifyShowTypes.matchesDupped:
        matches_current = matches_dupped;
        updateValue = deleteField();
        break;
      default:
        return;
    }

    const updates_matches = {}

    _.forEach(matches_current, (m, mk) => {
      const updateKey = currentShowType === _modifyShowTypes.unCancelled
        ? `matches.${m._itemKey}._isCancelled`
        : `matches.${m._itemKey}`;

      updates_matches[updateKey] = {
        value: updateValue,
        _matchCollectionKey: m?._matchCollectionKey,
      };
    });

    // _.forEach(matches_current, (m, mk) => {
    //   updates_matches[`matches.${m._itemKey}`] = {
    //     value: updateValue,
    //     _matchCollectionKey: m?._matchCollectionKey,
    //   }
    // })

    const updates_matches_grouped = getMatches_grouped({ updates_matches })

    const opts = { selectedYear, sportsKey }

    update_modifiedMatches({
      groupedMatchesToUpdate: updates_matches_grouped,
      opts,
    })
  }

  const handleUpdate_matchesRemoved = () => {

    const opts = { selectedYear, sportsKey }

    update_modifiedMatches({
      groupedMatchesToUpdate: matches_app_removed,
      opts,
    })
  }

  const handleUpdate_matchesMissingTiks = () => {

    const opts = { selectedYear, sportsKey }

    update_modifiedMatches({
      groupedMatchesToUpdate: matches_missingTiks_dot,
      opts,
    })
  }

  const handleUpdate_matchesTopLevel = () => {

    const opts = { selectedYear, sportsKey }

    update_modifiedMatches({
      groupedMatchesToUpdate: matches_missingTiks_topLevelDot,
      opts,
    })
  }

  const handleUpdate_matchesRemove = () => {

    const opts = { selectedYear, sportsKey }

    update_modifiedMatches({
      groupedMatchesToUpdate: matches_remove,
      opts,
    })
  }

  const handleUpdate_matchesDupped = () => {

    const opts = { selectedYear, sportsKey }

    // update_modifiedMatches({
    //   groupedMatchesToUpdate: matches_nonApp,
    //   opts,
    // })
  }

  const handleUpdate_nonApp = () => {

    const opts = { selectedYear, sportsKey }

    // update_modifiedMatches({
    //   groupedMatchesToUpdate: matches_nonApp,
    //   opts,
    // })
  }

  const handleUpdate_updates = () => {

  }

  const handleOnDrop = (item) => {
    const { itemType, _itemKey, date, isAway } = item ?? {}
    const _teamMatches = _.cloneDeep(matches_team);
    const _matches_team_new = _.cloneDeep(matches_team_new);
    switch (itemType) {
      case 'team':
        const _team = teams?.[_itemKey]
        const _opp = {
          name: _team.name,
          _itemKey: _team._itemKey,
          id: _team._itemKey,
          sections: _team.sections,
          levels: _team.levels
        }
        handleAdd_match(_opp, date, isAway)
        break;
      case 'match':
        const _match = _.find(_teamMatches, { _itemKey });
        if (_match) {
          _match.startDate = date;
          _match._updated = true
        }
        setMatches_team(_teamMatches);
        break;
      case '_match':
        const _matchh = _.find(_teamMatches, { _itemKey });
        if (_matchh) {
          _matchh.startDate = date;
          _matchh._updated = true
          setMatches_team(_teamMatches);
        }
        const _matchh_n = _.find(_matches_team_new, { _itemKey });
        if (_matchh_n) {
          _matchh_n.startDate = date;
          _matchh_n._updated = true
          setMatches_teamNew(_matches_team_new);
        }
        break;
      case 'remove':
        const _match_d = _.find(_teamMatches, { _itemKey });
        if (_match_d) {
          _match_d._removed = true
        }
        // _.remove(_teamMatches, { _itemKey })
        _.remove(_matches_team_new, { _itemKey })
        setMatches_team(_teamMatches);
        setMatches_teamNew(_matches_team_new);
        break;
    }
  }

  const handleSelect_match = (match) => {
    const isCancelled = !match._isCancelled;

    setMatches_season(prev =>
      _.map(prev, m =>
        m._itemKey === match._itemKey
          ? { ...m, _isCancelled: isCancelled }
          : m
      )
    );

    if (isCancelled) {
      // It was uncancelled → now cancelled, so remove it
      setMatches_unCancelled(prev =>
        _.filter(prev, m => m._itemKey !== match._itemKey)
      );
    } else {
      // It was cancelled → now uncancelled, so add it
      setMatches_unCancelled(prev =>
        _.some(prev, m => m._itemKey === match._itemKey)
          ? prev
          : [...prev, { ...match, _isCancelled: false }]
      );
    }
  };

  const handleAdd_match = (opp, sd, isAway) => {
    const _sel = {
      name: team_selected.name,
      _itemKey: team_selected._itemKey,
      id: team_selected._itemKey,
      sections: team_selected.sections,
      levels: team_selected.levels
    }
    const match = {
      away: isAway ? _sel : opp,
      home: isAway ? opp : _sel,
      startDate: sd,
      _matchCollectionKey: 'Non',
      _updated: true

    }
    const nm = createMatch(match, sd, '7:00 PM')
    const _teamMatches = _.cloneDeep(matches_team_new)
    _teamMatches.push(nm)
    setMatches_teamNew(_teamMatches)
  }

  const fnIcon = (item) => {
    const { _itemKey } = item
    const isSeasonalTeam = seasonalInfo?.teams?.[_itemKey] ? true : false
    return {
      icon: isSeasonalTeam ? 'check circle outline' : 'circle outline',
      iconColor: isSeasonalTeam ? 'blue' : 'red'
    }
  }

  const cnt_teams_selected = (item) => cnt_teams(item)
  const cnt_teams_opp = (item) => cnt_teams(item, true)

  const cnt_teams = (item, forOpp) => {

    const { sections, levels, _itemKey, name } = item

    const _matches = _.filter(matches_season, (match) =>
      _.includes(match.teams, _itemKey)
    );

    const _matches_opp = _.filter(matches_teamsCombined, (match) =>
      _.includes(match.teams, _itemKey)
    );

    const _matches_seasonal = _.filter(seasonalInfo?.matches, (match) =>
      _.includes(match.teams, _itemKey)
    );

    const _matches_seasonal_ns = _.filter(_matches, (match) =>
      match.levels === 'Non'
    );

    const _matches_nonGs = _.filter(matches_nonGs, (match) =>
      match?.home === name || match?.away === name
    );

    const _matches_nonApp = _.filter(matches_nonApp, (match) =>
      match?.home === name || match?.away === name
    );

    const _matches_conflicts = _.filter(matches_gs_conflicts, (match) =>
      match?.home === name || match?.away === name
    );

    const sectionMatch = forOpp && team_selected?.sections === sections ? true : false

    return <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '.25em' }}>
      {!forOpp && !_.isEmpty(_matches_nonGs) && <Label color={'purple'} size='mini' title='Non GS Matches'>{_.size(_matches_nonGs)}</Label>}
      {!forOpp && !_.isEmpty(_matches_nonApp) && <Label color={'pink'} size='mini' title='Non App Matches'>{_.size(_matches_nonApp)}</Label>}
      {!forOpp && !_.isEmpty(_matches_conflicts) && <Label color={'orange'} size='mini' title='Conflict Matches'>{_.size(_matches_conflicts)}</Label>}

      {!forOpp && !_.isEmpty(_matches_seasonal) && <Label color={'blue'} size='mini' title={'Seasonal Matches'}>{`SM:${_.size(_matches_seasonal)}`}</Label>}
      {!forOpp && !_.isEmpty(_matches) && <Label color={_.size(_matches) > maxMatchCount ? 'red' : 'green'} size='mini' title={'App Matches'}>{`TM:${_.size(_matches)}|NS:${_.size(_matches_seasonal_ns)}`}</Label>}


      {forOpp && sectionMatch && !_.isEmpty(_matches_opp) && <div title={'Section Match'}><Icon color={'blue'} name='check circle outline' /></div>}
      {forOpp && !_.isEmpty(_matches_opp) && <Label color={_.size(_matches_opp) > 2 ? 'red' : 'blue'} size='mini' title={'Opponent Match Count'}>{_.size(_matches_opp)}</Label>}

      <Label size='mini' color={'black'}>{`${levels} / ${_.startCase(sections)}`}</Label>

      {forOpp && <div
        draggable="true"
        onDragStart={(e) => {
          const dt = {
            _itemKey: item._itemKey,
            itemType: 'team',
            name: item?.name,
          }
          e.dataTransfer.setData('application/json', JSON.stringify(dt));
          handleSelect_opponent(item)
        }}
        style={{ cursor: 'grab', marginLeft: '.5em' }}
      >
        <Icon color='grey' name='expand arrows alternate' />
      </div>}
    </div>
  }

  const content_category = () => {
    const oc = (item) => {
      setCurrentCategory(item)
      setCurrentShowType()
      setMatch_selected()
      setMode_right()
    }
    const fnAlt = (item) => {
      switch (item) {
        case _categoryTypes.allMatches:
          return <Label size='tiny' color='blue'>{_.size(matches_combined)}</Label>
        case _categoryTypes.missingMatchResults:
          return <Label size='tiny' color={!_.isEmpty(missingMatches) ? 'blue' : 'grey'}>{_.size(missingMatches)}</Label>
        case _categoryTypes.matchDayMatches:
          return <Label size='tiny' color={!_.isEmpty(matchDayMatches) ? 'blue' : 'grey'}>{_.size(matchDayMatches)}</Label>
        case _categoryTypes.teams:
          return <Label size='tiny' color='blue'>{_.size(teams)}</Label>
        case _categoryTypes.cancelledMatches:
          return <Label size='tiny' color={!_.isEmpty(matches_cancelled) ? 'blue' : 'grey'}>{_.size(matches_cancelled)}</Label>
      }
    }

    // if (showOptions) {
    //   return menuItems_left()
    // }

    return <Wrapper
      header={'Categories'}
      content={<ItemMenuSquares
        menuItems={_categoryTypes}
        imsType={_imsTypes.inline}
        onClick={oc}
        activeItem={currentCategory}
        // fn_icon={fnIcon}
        fn_altContent={fnAlt}
      />}
      wrapperType={wrapperTypes.paddedHeader}
    />
  }

  const content_teams = (oc, seletedItem) => {
    let _sportSeasonTeams = _.sortBy(teams, 'name')
    return <Wrapper
      header={'Teams'}
      content={<ItemMenuSquares
        menuItems={_sportSeasonTeams}
        iconItem={'users'}
        imsType={_imsTypes.inline}
        onClick={oc}
        activeItem={seletedItem?.name}
        fn_icon={fnIcon}
        fn_altContent={cnt_teams_selected}
      />}
      wrapperType={wrapperTypes.paddedHeader}
    />
  }

  const getOpponentMatches = (teams) => {
    _.forEach(teams, team => {
      const _matches_opp = _.filter(matches_teamsCombined, (match) =>
        _.includes(match.teams, team?._itemKey)
      );
      team._matchCount = _.size(_matches_opp)
    })
  }

  const content_opponents = (oc, seletedItem) => {
    const updatedTeams = _.filter(teams, (team) => team?._itemKey !== team_selected?._itemKey);
    getOpponentMatches(updatedTeams)
    let _sportSeasonTeams = _.orderBy(updatedTeams, ['_matchCount', 'name'], ['desc', 'asc'])
    return <Wrapper
      header={`Opponents: ${!_.isEmpty(team_selected) ? team_selected?.name : 'Select Team'}`}
      content={!_.isEmpty(team_selected) ? <ItemMenuSquares
        menuItems={_sportSeasonTeams}
        iconItem={'users'}
        imsType={_imsTypes.inline}
        onClick={oc}
        activeItem={seletedItem?.name}
        fn_altContent={cnt_teams_opp}
        noItemIcon={true}
      /> : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'Select Team'}</div>}
      wrapperType={wrapperTypes.paddedHeader}
    />
  }

  const header_calendar = () => <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <div>{!_.isEmpty(team_selected) ? `${team_selected?.name} Calendar: ${_.size(matches_teamsCombined)} Match(es)` : 'Calendar'}</div>
    <div><Icon
      name='trash alternate outline'
      onDrop={(e) => {
        e.preventDefault();
        const dt = JSON.parse(e.dataTransfer.getData('application/json'));
        handleOnDrop({
          itemType: 'remove',
          _itemKey: dt?._itemKey,
        })
      }}
    /></div>
  </div>


  const content_calendar = () => <Wrapper
    // header={team_selected ? header_calendar() : 'Calendar'}
    content={!_.isEmpty(team_selected) ? <CalSchedule
      matches={matches_teamsCombined}
      matches_opp={matches_teamsOppCombined}
      teamKey={team_selected?._itemKey}
      handle_onDrop={handleOnDrop}
    /> : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'Select Team'}</div>}
    wrapperType={wrapperTypes.paddedHeader}
  />


  const content_matches_selected = () => {
    const oc = (m) => handleMatchSelected(m)
    const _matches_teamSeasonal = _.filter(seasonalInfo?.matches, (match) =>
      _.includes(match.teams, team_selected?._itemKey)
    );
    // const matches_teamNonGs = _.filter(matches_nonGs, (match) =>
    //   _.includes(match.teams, team_selected?._itemKey)
    // );
    const matches_teamNonGs = _.filter(matches_nonGs, (match) =>
      match?.home === team_selected?.name || match?.away === team_selected?.name
    );
    return <Wrapper
      // header={!_.isEmpty(team_selected) ? `${team_selected?.name}: ${_.size(matches_teamsCombined)} Match(es)` : 'Matches'}
      content={!_.isEmpty(team_selected) ? <TeamSchedule
        teamKey={team_selected?._itemKey}
        matches_team={matches_teamsCombined}
        allowDrag={false}
        matches_teamSeasonal={_matches_teamSeasonal}
        matches_teamNonGs={matches_teamNonGs}
        oc={oc}
      // matches_missAssigned={matches_missAssigned}
      /> : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'Select Team'}</div>}
      wrapperType={wrapperTypes.paddedHeader}
      updating={updating}
    />
  }

  const content_calendar_selected = () => {
    switch (calendarType) {
      case _calendarTypes.calendar:
        return content_calendar()
      case _calendarTypes.list:
        return content_matches_selected()
    }
  }

  const content_calendars = () => {
    const oc = (item) => setCalendarType(item)
    return <Wrapper
      header={!_.isEmpty(team_selected) ? `${team_selected?.name}: ${_.size(matches_teamsCombined)} Match(es)` : 'Matches'}
      navigation={!_.isEmpty(team_selected) && <ItemMenuSquares menuItems={_calendarTypes} imsType={_imsTypes.menu} onClick={oc} activeItem={calendarType} />}
      content={content_calendar_selected()}
      wrapperType={wrapperTypes.paddedHeader}
    />
  }

  const fnAlt_non = (item) => {
    const { updateTypes, _gsid, _conflictTypes, _isCancelled, _matchCollectionKey } = item ?? {}
    let color;
    let iconName;
    const divs = []
    switch (updateTypes) {
      case _matchFoundTypes.cancelled:
      case 'Cancelled':
        color = matchStatusColors.cancelled
        iconName = 'ban'
        divs.push(<div><Icon title={'Cancelled'} name={iconName} color={color} /></div>)
        break;
      default:
    }
    if (_conflictTypes && _.includes(_conflictTypes, _matchConflictTypes.overlap)) {
      divs.unshift(<div><Icon name={'calendar times outline'} color={'red'} /></div>)
    }
    if (_conflictTypes && _.includes(_conflictTypes, _matchConflictTypes.duplicateMatch)) {
      divs.unshift(<div><Icon name={'copy'} color={'orange'} /></div>)
    }
    if (_conflictTypes && _.includes(_conflictTypes, _matchConflictTypes.overlap)) {
      divs.unshift(<div><Icon name={'calendar minus outline'} color={'red'} /></div>)
    }
    if (_isCancelled) {
      const matchingMatch = matches_gs_cancelled ? _.find(matches_gs_cancelled, { away: item?.away?.name, home: item?.home?.name }) : null
      if (matchingMatch) {
        divs.unshift(<div><Icon name={'google drive'} color={'green'} /><Icon name={'ban'} color={'red'} /></div>)
      } else {
        divs.unshift(<div><Icon name={'ban'} color={'red'} /></div>)
      }

    }
    if (_matchCollectionKey) {
      divs.unshift(<div>{_matchCollectionKey}</div>)
    }
    divs.push(<div>{_gsid}</div>)
    return <div style={{ display: 'flex', columnGap: '.5em' }}>
      {divs}
    </div>
  }

  const getTeamName = team => typeof team === 'string' ? team : team?.name

  const getMatchKey = match => {
    const home = getTeamName(match?.home)
    const away = getTeamName(match?.away)
    if (!home || !away) return null
    return `${home}|||${away}`
  }

  const fnSub_non = (item) => {
    const { _conflicts, startDate, _itemKey, teams, _teamsOld, results } = item ?? {}
    const divs = !_.isEmpty(_conflicts) ? _.map(_conflicts, confict => (<div>{confict}</div>)) : []
    divs.unshift(<div>{startDate}</div>)

    if (results) {
      divs.push(<div><Label size='tiny' color='blue'>{`${results?.score?.away} - ${results?.score?.home}`}</Label></div>)
    }

    switch (currentShowType) {
      case _modifyShowTypes.reassignedTeams:
        divs.push(<div>{_.join(teams, ', ')}</div>)
        divs.push(<div>{_.join(_teamsOld, ', ')}</div>)
        break;
      case _modifyShowTypes.nonGs:
        const key = getMatchKey(item);
        const gsMap = _.keyBy(matches_gs, getMatchKey)
        const gs = gsMap?.[key]
        break;
      case _modifyShowTypes.matchUpdates:
        divs.push(<div>{'UDM'}</div>)
      // console.log('matches_gs', matches_gs)
    }

    if (_itemKey) { divs.unshift(<div>{_itemKey}</div>) }

    return <div style={{ display: 'flex', flexDirection: 'column' }}>
      {divs}
    </div>
  }

  const footer_matches = () => {
    const btn = {
      color: _allowSportsUpdates.modifications ? 'green' : 'teal',
      icon: _allowSportsUpdates.modifications ? 'save' : 'arrow right',
      oc: null,
      caption: 'Update'
    }
    switch (currentShowType) {
      case _modifyShowTypes.cancelled:
      case _modifyShowTypes.nonGs:
        btn.oc = handleUpdate_matchesSelected
        btn.caption = `Remove ${_.startCase(currentShowType)} Matches`
        break;

      case _modifyShowTypes.matchesDupped:
        btn.oc = handleUpdate_matchesSelected
        btn.caption = `Remove Dupped App Matches: ${_.size(matches_dupped)}`
        break;

      case _modifyShowTypes.unCancelled:
        btn.oc = handleUpdate_matchesSelected
        btn.caption = `Un-Cancel ${_.startCase(currentShowType)} Matches`
        break;

      case _modifyShowTypes.reassignedTeams:
        btn.oc = handleUpdate_matchesReassigned
        btn.caption = 'Update Reassigned Teams Matches'
        break;

      case _modifyShowTypes.removed:
        btn.oc = handleUpdate_matchesRemoved
        btn.caption = `Remove No Team Matches`
        break;

      case _modifyShowTypes.matchesMissingTiks:
        btn.oc = handleUpdate_matchesMissingTiks
        btn.caption = `Update Missing Tiks Matches: ${_.size(matches_missingTiks)}`
        break;

      case _modifyShowTypes.matchesTopLevel:
        btn.oc = handleUpdate_matchesTopLevel
        btn.caption = `Remove Top Level Matches: ${_.size(matches_missingTiks_topLevelDot)}`
        break;

      case _modifyShowTypes.matchesRemove:
        btn.oc = handleUpdate_matchesRemove
        btn.caption = `Remove Top Level Matches: ${_.size(matches_remove)}`
        break;

      case _modifyShowTypes.nonApp:
        btn.oc = handleUpdate_nonApp
        btn.caption = `Add Non App Matches: ${_.size(matches_nonApp)}`
        break;

      case _modifyShowTypes.matchUpdates:
        btn.oc = handleUpdate_updates
        btn.caption = `Update Matches: ${_.size(matches_updates)}`
        break;

      case _modifyShowTypes.conflicts:
        break;
    }
    if (btn.oc) {
      const btns = []
      btns.push(btn)
      return <UiSaveButtons others={btns} />
    }
  }

  const content_matches = () => {
    let content;
    let oc;
    let icon;
    switch (currentShowType) {
      case _modifyShowTypes.cancelled:
        content = _.sortBy(matches_cancelled, 'startDate')
        oc = handleSelect_match
        break;
      case _modifyShowTypes.unCancelled:
        content = matches_unCancelled
        oc = handleSelect_match
        break;
      case _modifyShowTypes.conflicts:
        icon = <Icon name={'google drive'} color='green' />
        content = _.sortBy(matches_gs_conflicts, 'startDate')
        break;
      case _modifyShowTypes.nonApp:
        content = matches_nonApp
        break;
      case _modifyShowTypes.matchesDupped:
        content = matches_dupped
        break;
      case _modifyShowTypes.nonGs:
        content = _.sortBy(matches_nonGs, 'startDate')
        break;
      case _modifyShowTypes.reassignedTeams:
        content = matches_reassignedTeams
        break;
      case _modifyShowTypes.removed:
        content = matches_app_removed
        break;
      case _modifyShowTypes.matchesMissingTiks:
        content = matches_missingTiks
        break;
      case _modifyShowTypes.matchesTopLevel:
        content = matches_missingTiks_topLevelDot
        break;
      case _modifyShowTypes.matchesRemove:
        content = matches_remove
        break;
      case _modifyShowTypes.matchUpdates:
        return content_updates()
        break;
    }

    return <Wrapper
      header={<div>{icon}{`${_.startCase(currentShowType)} Match(es): ${_.size(content)}`}</div>}
      content={<ItemMenuSquares
        menuItems={content}
        imsType={_imsTypes.match}
        showItemKey={true}
        noItemIcon={true}
        fn_altContent={fnAlt_non}
        fn_subContent={fnSub_non}
        onClick={oc}
      />}
      footer={footer_matches()}
      wrapperType={wrapperTypes.paddedHeader}
    />
  }

  const content_updates = () => <MatchSquares matches={matches_updates} showChanges={true} forPlayoffs={false} />

  const content_match = () => {
    const { _status } = match_selected
    const btns = []
    const btn1 = {
      color: _allowSportsUpdates.modifications ? 'green' : 'teal',
      icon: _allowSportsUpdates.modifications ? 'save' : 'arrow right',
      oc: handleUpdate_matchesRemove,
      caption: 'Update'
    }
    const btn2 = {
      icon: 'delete',
      oc: handleMatchSelected,
      caption: 'Cancel',
      color: 'black',
      fl: true
    }
    btns.push(btn1)
    btns.push(btn2)
    const footer = <UiSaveButtons others={btns} />
    return <Wrapper
      header={<div>{_status?.matchName}</div>}
      content={<ItemMenuSquares
        menuItems={[match_selected]}
        imsType={_imsTypes.match}
        showItemKey={true}
        noItemIcon={true}
        fn_altContent={fnAlt_non}
        fn_subContent={fnSub_non}
      />}
      footer={footer}
      wrapperType={wrapperTypes.paddedHeader}
    />
  }

  const pl = () => <SquaresOptions
    title={'Options'}
    caption={'Options'}
    menuGroup={matchDataOptions}
    position='top left'
  />

  const btn = (content, icon, showType, allowClick) => <Button
    labelPosition='right'
    content={content}
    size='mini'
    color={allowClick ? 'blue' : 'grey'}
    icon={icon}
    onClick={() => { allowClick && handleShowType(showType) }}
  />


  const footer_main = () => {

    const btns_left = []
    const btns_right = []

    btns_left.push(pl())

    if ((!currentShowType || currentShowType === _modifyShowTypes.reassignedTeams) && !_.isEmpty(matches_reassignedTeams)) {
      btns_right.push(
        btn(
          currentShowType === _modifyShowTypes.reassignedTeams ? 'Hide Reassigned Team Match(es)' : `Reassigned Team Match(es): ${_.size(matches_reassignedTeams)}`,
          currentShowType === _modifyShowTypes.reassignedTeams ? 'arrow left' : 'arrow right',
          _modifyShowTypes.reassignedTeams,
          !_.isEmpty(matches_reassignedTeams))
      )
    }

    if ((!currentShowType || currentShowType === _modifyShowTypes.nonGs) && !_.isEmpty(matches_nonGs)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.nonGs ? 'Hide Non GS Match(es)' : `Non GS Match(es): ${_.size(matches_nonGs)}`,
          currentShowType === _modifyShowTypes.nonGs ? 'arrow left' : 'arrow right',
          _modifyShowTypes.nonGs,
          !_.isEmpty(matches_nonGs)
        )
      )
    }

    if ((!currentShowType || currentShowType === _modifyShowTypes.nonApp) && !_.isEmpty(matches_nonApp)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.nonApp ? 'Hide Non App Match(es)' : `Non App Match(es): ${_.size(matches_nonApp)}`,
          currentShowType === _modifyShowTypes.nonApp ? 'arrow left' : 'arrow right',
          _modifyShowTypes.nonApp,
          !_.isEmpty(matches_nonApp)
        )
      )
    }

    if ((!currentShowType || currentShowType === _modifyShowTypes.matchesDupped) && !_.isEmpty(matches_dupped)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.matchesDupped ? 'Hide Dupped App Match(es)' : `Dupped App Match(es): ${_.size(matches_dupped)}`,
          currentShowType === _modifyShowTypes.matchesDupped ? 'arrow left' : 'arrow right',
          _modifyShowTypes.matchesDupped,
          !_.isEmpty(matches_dupped)
        )
      )
    }

    if ((!currentShowType || currentShowType === _modifyShowTypes.conflicts) && !_.isEmpty(matches_gs_conflicts)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.conflicts ? 'Hide Conflict Match(es)' : `Conflict Match(es): ${_.size(matches_gs_conflicts)}`,
          currentShowType === _modifyShowTypes.conflicts ? 'arrow left' : 'arrow right',
          _modifyShowTypes.conflicts,
          !_.isEmpty(matches_gs_conflicts)
        )
      )
    }

    if ((!currentShowType || currentShowType === _modifyShowTypes.cancelled) && !_.isEmpty(matches_cancelled)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.cancelled ? 'Hide Cancelled Match(es)' : `Cancelled Match(es): ${_.size(matches_cancelled)}`,
          currentShowType === _modifyShowTypes.cancelled ? 'arrow left' : 'arrow right',
          _modifyShowTypes.cancelled,
          !_.isEmpty(matches_cancelled)
        )
      )
    }

    if ((!currentShowType || currentShowType === _modifyShowTypes.unCancelled) && !_.isEmpty(matches_unCancelled)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.unCancelled ? 'Hide Un-Cancelled Match(es)' : `Un-Cancelled Match(es): ${_.size(matches_unCancelled)}`,
          currentShowType === _modifyShowTypes.unCancelled ? 'arrow left' : 'arrow right',
          _modifyShowTypes.unCancelled,
          !_.isEmpty(matches_unCancelled)
        )
      )
    }

    if ((!currentShowType || currentShowType === _modifyShowTypes.removed) && !_.isEmpty(matches_nonTeam)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.removed ? 'Hide Removed Match(es)' : `Removed Match(es): ${_.size(matches_nonTeam)}`,
          currentShowType === _modifyShowTypes.removed ? 'arrow left' : 'arrow right',
          _modifyShowTypes.removed,
          !_.isEmpty(matches_nonTeam)
        )
      )
    }

    if ((!currentShowType || currentShowType === _modifyShowTypes.matchesMissingTiks) && !_.isEmpty(matches_missingTiks)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.matchesMissingTiks ? 'Hide Missing Tiks Match(es)' : `Update Missing Tiks Match(es): ${_.size(matches_missingTiks)}`,
          currentShowType === _modifyShowTypes.matchesMissingTiks ? 'arrow left' : 'arrow right',
          _modifyShowTypes.matchesMissingTiks,
          !_.isEmpty(matches_missingTiks)
        )
      )
    }

    if ((!currentShowType || currentShowType === _modifyShowTypes.matchesTopLevel) && !_.isEmpty(matches_missingTiks_topLevelDot)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.matchesTopLevel ? 'Hide Top Level Match(es)' : `Remove Top Level Match(es): ${_.size(matches_missingTiks_topLevelDot)}`,
          currentShowType === _modifyShowTypes.matchesTopLevel ? 'arrow left' : 'arrow right',
          _modifyShowTypes.matchesTopLevel,
          !_.isEmpty(matches_missingTiks_topLevelDot)
        )
      )
    }


    if ((!currentShowType || currentShowType === _modifyShowTypes.matchesRemove) && !_.isEmpty(matches_remove)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.matchesRemove ? 'Hide Remove Match(es)' : `Remove Match(es): ${_.size(matches_remove)}`,
          currentShowType === _modifyShowTypes.matchesRemove ? 'arrow left' : 'arrow right',
          _modifyShowTypes.matchesRemove,
          !_.isEmpty(matches_remove)
        )
      )
    }

    if ((!currentShowType || currentShowType === _modifyShowTypes.matchUpdates) && !_.isEmpty(matches_updates)) {
      btns_right.unshift(
        btn(
          currentShowType === _modifyShowTypes.matchUpdates ? 'Update Match(es)' : `Update Match(es): ${_.size(matches_updates)}`,
          currentShowType === _modifyShowTypes.matchUpdates ? 'arrow left' : 'arrow right',
          _modifyShowTypes.matchUpdates,
          !_.isEmpty(matches_updates)
        )
      )
    }

    return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
        {btns_left}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {btns_right}
      </div>
    </div >
  }

  const filterMissing = (data) => {
    const predicate = (item) => _.get(item, '_status.isMissing') === true;

    return _.isArray(data)
      ? _.filter(data, predicate)
      : _.pickBy(data, predicate);
  };

  const menu_vert_existing = useMemo(() => {
    const count = _counts.matches;
    const _caption = _.startCase('existingMatches')
    return (
      <Wrapper
        header={header_flex(_caption, count)}
        content={
          <MatchSquares matches={matches_combined} msType={_msTypes.base} fromLookup={true} />
        }
        wrapperType={wrapperTypes.paddedHeader}
      />
    );
  }, []);

  const menu_vert_missing = useMemo(() => {
    const count = _counts.missing;
    const mm = filterMissing(matches_combined)
    const _caption = _.startCase('missingResults')
    return <Wrapper
      header={header_flex(_caption, count)}
      content={<MatchSquares matches={mm} />}
      wrapperType={wrapperTypes.paddedHeader}
    ></Wrapper>
  }, [missingMatches]);

  const menu_vert_cancelled = useMemo(() => {
    const count = _counts.missing;
    const _caption = _.startCase('cancelledMatches')
    return <Wrapper
      header={header_flex(_caption, count)}
      content={<MatchSquares matches={matches_cancelled} />}
      wrapperType={wrapperTypes.paddedHeader}
    ></Wrapper>
  }, [matches_cancelled]);

  const contents_category = () => {

    const wvcs = []

    if (currentShowType) {
      wvcs.push(content_matches())
    } else {
      switch (currentCategory) {
        case _categoryTypes.allMatches:
          wvcs.push(menu_vert_existing)
          break;

        case _categoryTypes.missingMatchResults:
          wvcs.push(menu_vert_missing)
          break;

        case _categoryTypes.cancelledMatches:
          wvcs.push(menu_vert_cancelled)
          break;

        case _categoryTypes.matchDayMatches:
          wvcs.push(menu_vert_matchDay)
          break;

        case _categoryTypes.matchPlayoffPending:
          wvcs.push(menu_vert_matchPlayoffPendings)
          break;

        case _categoryTypes.teams:
          wvcs.push(teams ? content_teams(handleSelect_team, team_selected) : <div>Away Team</div>)
          wvcs.push(teams ? content_opponents(handleSelect_opponent, team_opponent) : <div>Home Team</div>)
          wvcs.push(content_calendars())
          if (currentShowType) {
            // wvcs.push(content_matches())
          } else {
            // wvcs.push(content_matches_selected())
          }
          break;

        default:
          wvcs.push(<div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'Select Category'}</div>)
      }
    }
    return wvcs
  }

  const content_extra = () => {
    if (!_.isEmpty(match_selected)) {
      return content_match()
    } else if (mode_right) {
      return <MatchesExtra mode_right={mode_right} forPlayoffs={false} />
    }
  }

  const mvc_full = () => {
    let _mvc = currentCategory && !currentShowType ? `msm-${currentCategory}` : 'msm'
    if (currentShowType) { _mvc += ' cst' }
    if (!_.isEmpty(match_selected)) { _mvc += ' msel' }
    if (mode_right) { _mvc += ' mrsel' }
    return <WrapperVertCols mvc={_mvc}>
      {content_category()}
      {!mode_right && contents_category()}
      {content_extra()}
    </WrapperVertCols>
  }

  const mvc_team = () => <div className={'team-scheduler'}>
    {content_calendar()}
    {content_opponents(handleSelect_opponent, team_opponent)}
  </div>

  const content_season = () => <Wrapper
    content={teamKey ? mvc_team() : mvc_full()}
    footer={footer_main()}
    wrapperType={wrapperTypes.paddedFooter}
    updating={updating}
  ></Wrapper>

  return (
    content_season()
  )
}
